'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

/**
 * Used to show a "required" text or an asterisks (*) to indicate that
 * a field is required.
 */
var RequiredIndicator = react.forwardRef(function (props, ref) {
  var field = react.useFormControlContext();
  var styles = react.useStyleConfig('RequiredIndicator');
  var className = utils.cx('chakra-label__required-indicator', props.className);
  return /*#__PURE__*/React__namespace.createElement(react.chakra.span, _extends__default["default"]({}, field === null || field === void 0 ? void 0 : field.getRequiredIndicatorProps(props, ref), {
    __css: styles,
    className: className
  }), "*");
});
RequiredIndicator.displayName = 'RequiredIndicator';
exports.RequiredIndicator = RequiredIndicator;